<template>
    <div class="aside-title">
        <slot>
            {{ title }}
        </slot>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        title: {
            type: String,
            default: '',
        },
    },
    data() {
        return {};
    },
    computed: {},
    methods: {},
    created() {},
    mounted() {},
    watch: {},
};
</script>

<style lang="scss" scoped>
.aside-title {
    padding-top: 11px;
    text-align: center;
    font-size: 18px;
    height: 37px;
    background-image: url(../../imgs/titlebg01.png);
}
</style>
